import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination/index";
import NavBarTitles from "../../components/Common/TabBar";
import { Inventory, sizeofPharmacy } from "../../components/Constants";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../components/Modal/SucessModal";
import ExcelDownload from "../../components/Utils/excelDownload";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";
import {
  HealthSynergynavBarData,
  PartneredDoctorscolumnOrder,
  PartneredPharmacy,
  PharmacyRegistrationTable,
} from "./HealthSynergyConst";
import "./healthsy.scss";

const emptyFilterValues = {
  Inventory: [],
  "City / Town": [],
  "Size of Pharmacy": [],
  "Business Type": [],
  "Lead Status": [],
  BD: [],
};

const RetailPharmacy = () => {
  // Sorting
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  // Filters
  const [leadStatus, setLeadStatus] = useState([]);
  const [businessType, setbusinessType] = useState([]);
  const [bdModal, setBdModal] = useState([]);
  const [selectedValues, setSelectedValues] = useState(emptyFilterValues);
  const [selectedCategory, setSelectedCategory] = useState("Inventory");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [tempSelectedValues, setTempSelectedValues] =
    useState(emptyFilterValues);

  const [loader, setLoader] = useState(true);
  // Delete
  const [showDelete, setShowDelete] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [deleteId, setDeleteId] = useState("");

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}pharmacy-registration/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    selectedValues,
    success,
    leadStatussuccess,
  ]);

  const handleDelete = useDeleteHandler(
    "pharmacy-registration",
    fetchData,
    setShowDelete
  );

  const handlePageChange = usePageChange(pagination, setPagination);

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
  };
  const fetchAndMap = async (url, mapFn) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}${url}`,
        { noLimit: true }
      );
      return data || [];
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      return [];
    }
  };

  useEffect(() => {
    const fetchArrayData = async () => {
      const [leadStatuses, bdModals, businessType] = await Promise.all([
        fetchAndMap("lead-status/getarray", (lead) => lead),
        fetchAndMap("bd/getarray", (bd_name) => bd_name),
        fetchAndMap("pharmacy-business-type/getarray", (type) => type),
      ]);
      setLeadStatus(leadStatuses);
      setBdModal(bdModals);
      setbusinessType(businessType);
    };

    fetchArrayData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filters = useMemo(
    () => ({
      Inventory: Inventory,
      "City / Town": [],
      "Size of Pharmacy": sizeofPharmacy,
      "Business Type": businessType,
      "Lead Status": leadStatus,
      BD: bdModal,
    }),
    [Inventory, sizeofPharmacy, businessType, leadStatus, bdModal]
  );

  const onClickDownload = async () => {
    try {
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "N/A",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "N/A",
        "First Name": record.first_name || "N/A",
        "Last Name": record.last_name || "N/A",
        "Pharmacy Name": record.pharmacy_name || "N/A",
        "Mobile Number": record.mobile || "N/A",
        "Email ID": record.email || "N/A",
        "Pharmacy Business Type": record.business_type || "N/A",
        "Company Name": record.company_name || "N/A",
        "Pharmacy GST Number": record.gst_no || "N/A",
        "Drug License Number": record.pharmacy_registration_number || "N/A",
        "FSSAI Number": record.fssai_license_no || "N/A",
        "Pharmacist Name": "Unknown", // Replace with actual pharmacist name if available
        "Your pharmacist's license number":
          record.pharmacist_license_number || "N/A",
        State: record.state || "N/A",
        City: record.pharmacy_town || "N/A",
        "Pharmacy Location": record.pharmacy_address || "N/A",
        Address: record.pharmacy_address || "N/A",
        Pincode: record.pincode || "N/A",
        "Medicines Listing Fee (%)": "N/A", // Add logic if available
        "OTC Listing Fee (%)": record.discount_on_OTC || "N/A",
        "What is the approximate size of your pharmacy store?":
          record.size || "N/A",
        "What is the value of inventory you have in your pharmacy store?":
          record.value_of_inventory || "N/A",
        "How many pharmacists are working in your pharmacy?":
          record.pharmacists_count || "N/A",
        "Do you have a delivery person / staff to deliver orders to your customers?":
          record.have_delivery_person || "N/A",
        "Delivery Person Name": record?.delivery_person_name || "N/A",
        "Delivery Person Number": record?.delivery_person_number || "N/A",
        "Do you have Poc for your retail pharmacy store": "No", // Replace with actual PoC details if available
        "Poc Name": "N/A",
        "Poc Number": "N/A",
        "Are you currently part of any online pharmacy / health-tech platforms?":
          record.online_pharmacy || "N/A",
        "Do you have a wholesale license?":
          record.have_wholesale_license || "N/A",
        "Do you currently use any billing / sales / ERP software?":
          record.billing_software || "N/A",
        "Pharmacy Available": "N/A", // Add logic if available
        "Pharmacy Start Time": "N/A", // Add logic if available
        "Pharmacy End Time": "N/A", // Add logic if available
        "BD Name": "N/A", // Replace with actual BD Name if available
        "App Download Android Click": record.android_click || 0,
        "Brochure Icon Click Status (1.0)": record.brochure_click || 0,
        "Assigned To": record.assigned_to || "N/A",
        "Lead Status": record.lead_status || "N/A",
        // "Actions": "N/A", // Uncomment if action logic needs to be added
      }));

      ExcelDownload(
        formattedRecords,
        PartneredDoctorscolumnOrder,
        "pharmacy-registrations.xlsx"
      );
      // console.log("File downloaded successfully.");
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message
      );
      // console.error("Error downloading the file:", err.message);
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={PartneredPharmacy}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total Partnered Doctors : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={pagination.limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <DoctorsFilterOptions
            limit={pagination.limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            // setSortShow={setSortShow}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
          <PharmacyRegistrationTable
            records={records}
            skip={pagination.skip}
            setAssignModal={setAssignModal}
            setLeadStatusModal={setLeadStatusModal}
            setDeleteId={setDeleteId}
            setShowDelete={setShowDelete}
            loader={loader}
          />
        </div>
      </MainconternLayout>

      {showDelete && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          // fetchData();
        }}
        onReset={() => {
          setSelectedValues(emptyFilterValues);
          setTempSelectedValues(emptyFilterValues);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />

      {assignModal.status && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="partnered-doctor-inclinic"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/pharmacy-registration"
        />
      )}

      {leadStatusModal.status && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
        />
      )}

      {leadStatusConfirmModal.status && (
        <LeadStatusConfirm
          id={leadStatusConfirmModal?.leadType}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          leadStatusConfirmModal={leadStatusConfirmModal}
          formType="pharmacy-registration"
        />
      )}

      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page="/pharmacy-registration"
        />
      )}

      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default RetailPharmacy;
